export default __webpack_public_path__ + "static/media/flag_us.fa36a35f.svg";